import React, { useMemo } from 'react';

/**
 * Returns a memoized `CSSStyleDeclaration` object.
 */
export function useStyles(styles: React.CSSProperties): React.CSSProperties {
  return useMemo(() => ({ ...styles }), [JSON.stringify(styles)]);
}
